// extracted by mini-css-extract-plugin
export default {"roster":"FullRosterView_roster__3HNPN","rosterButton":"FullRosterView_rosterButton__iw80d"};